import { Component, OnInit } from "@angular/core";
import { CatDelegacionesService } from "../../servicios/cat-delegaciones.service";
import { MuestraMensaje } from "../../shared/utilerias/notificaciones/notificaciones.component";
import { MenuItem, SelectItem } from "primeng/api";
import { CatDelegaciones } from "../../entidades/entidades";
import { CatMunicipiosService } from "app/servicios/cat-municipios.service";
@Component({
  selector: "app-cat-delegaciones-grid",
  templateUrl: "./cat-delegaciones-grid.component.html",
  styleUrls: ["./cat-delegaciones-grid.component.css"],
})
export class CatDelegacionesComponent implements OnInit {
  public muestraMensaje = new MuestraMensaje();
  public catDelegaciones: CatDelegaciones[];
  public itemsMenu: MenuItem[];
  public columnasTabla: any[];
  public clonedCatDelegaciones: { [s: string]: CatDelegaciones } = {};
  public catMunicipios: SelectItem[];
  public progressBar: boolean = false;

  constructor(
   private catDelegacionesService: CatDelegacionesService,
   private catMunicipiosService: CatMunicipiosService
  ) {}

  ngOnInit(): void {
    this.getCatMunicipios();
    this.getAllCatDelegaciones();
  
    // ===============================================================
    //Opciones del menu
    // ===============================================================
    // prettier-ignore
    this.itemsMenu = [
      {label: "Agregar",   icon: "pi pi-file-o",  command: () => this.add(), },
      {label: "Guardar",   icon: "pi pi-save",    command: (event) => {this.guardarGridCatDelegaciones();} },
      {label: "Refrescar", icon: "pi pi-refresh", command: (event) => {this.getAllCatDelegaciones();} },
    ];

    // ===============================================================
    //Opciones de la tabla
    // ===============================================================
    // prettier-ignore
    this.columnasTabla = [
      {field: "operacion",header: "", ordenar: false, styleHeader: "width: 30px;"},
      {field: "descripcion", header: "Descripción",ordenar: true, styleHeader: "width: 150px;",},
      //{field: "idMunicipio", header: "Municipio",ordenar: true, styleHeader: "width: 150px;",},
      {field: "acciones", header: "",ordenar: false, styleHeader: "width: 30px;",},
    ];
  }
  //===============================================================
  //Agrega renglon en el grid
  //===============================================================
  // prettier-ignore  //
  add() { 

    //verificamos si el input del filtro descripcion tiene valor para incar al usuario que limpie el filtro
    let descripcion = (<HTMLInputElement>document.getElementById("inputFiltro"));
    if (descripcion.value !== "") {
      this.muestraMensaje.warning("Para agregar un nuevo registro, limpie el filtro de búsqueda.", "top", "center");
      return;
    }

    let catDelegacionesNew = new CatDelegaciones();
    catDelegacionesNew.cambio = true;
    catDelegacionesNew.id = 0;
    catDelegacionesNew.numRow = this.catDelegaciones.length + 1;
    catDelegacionesNew.baja = false;
    catDelegacionesNew.idMunicipio = this.catMunicipios[0].value;

    this.catDelegaciones.unshift(catDelegacionesNew);
  }

  //===============================================================
  //Funciones de la tabla
  //===============================================================
  // prettier-ignore
  onEditInit(event) {
    let catDelegacionesEdit = event.data;
    this.clonedCatDelegaciones[catDelegacionesEdit.numRow] = { ...catDelegacionesEdit };
    catDelegacionesEdit.cambio = true;
    catDelegacionesEdit.baja = false;
  }

  // prettier-ignore
  onEditCancel(event) {
    let catDelegacionesEdit = event.data;
    let index = this.catDelegaciones.findIndex(
      (obj) => obj.numRow === catDelegacionesEdit.numRow
    );
    this.catDelegaciones[index] = { ...this.clonedCatDelegaciones[catDelegacionesEdit.numRow]};
  }

  // prettier-ignore
  onDelete(event, index: number) {
    event.cambio = false;
    event.baja = true;
  }

  // prettier-ignore
  async onEditComplete(event) {
    try {
      let catDelegacionesEdit = event.data;

      //Valida si hay cambios
      if (
        catDelegacionesEdit.id === this.clonedCatDelegaciones[catDelegacionesEdit.numRow].id &&
        catDelegacionesEdit.descripcion === this.clonedCatDelegaciones[catDelegacionesEdit.numRow].descripcion &&
        catDelegacionesEdit.idMunicipio === this.clonedCatDelegaciones[catDelegacionesEdit.numRow].idMunicipio 
      ) {
        let index = this.catDelegaciones.findIndex((obj) => obj.numRow === catDelegacionesEdit.numRow);
        this.catDelegaciones[index] = {...this.clonedCatDelegaciones[catDelegacionesEdit.numRow]};
        return;
      }

      //Valida descripcion vacia
      if (catDelegacionesEdit.descripcion === "" || catDelegacionesEdit.descripcion === null || catDelegacionesEdit.descripcion === undefined) {
        this.muestraMensaje.error("La descripción no puede estar vacía.", "top", "center");
        let index = this.catDelegaciones.findIndex((obj) => obj.numRow === catDelegacionesEdit.numRow);
        this.catDelegaciones[index] = { ...this.clonedCatDelegaciones[catDelegacionesEdit.numRow] };
        return;
      }

      catDelegacionesEdit.cambio = true;
      catDelegacionesEdit.baja = false;
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    }
  }
  //===============================================================
  //Interaccion con servicios
  //===============================================================
  // prettier-ignore
  async guardarGridCatDelegaciones() {
    try {
      this.progressBar = true;

      for (let catDelegacionesFor of this.catDelegaciones) {

        //valida descripcion vacia
        if (catDelegacionesFor.descripcion === "" || catDelegacionesFor.descripcion === null || catDelegacionesFor.descripcion === undefined) {
          throw new Error("La descripción no puede estar vacía.");
        }

        if (catDelegacionesFor.baja) {
          await this.deleteCatDelegaciones(catDelegacionesFor);
        } else if (catDelegacionesFor.cambio) {
          catDelegacionesFor.cambio = false;
          this.clonedCatDelegaciones[catDelegacionesFor.id] = { ...catDelegacionesFor, };
          if (catDelegacionesFor.id === 0) {
            const datoRetorno = await this.addCatDelegaciones(catDelegacionesFor);
            catDelegacionesFor.id = datoRetorno.id;
          } else {
            await this.updateCatDelegaciones(catDelegacionesFor);
          }
        }
      }

      this.muestraMensaje.notification("Proceso Concluido.", "top", "center");
      //volvemos a cargar la tabla
      this.getAllCatDelegaciones();
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    } finally {
      this.progressBar = false;
    }
  }

  // prettier-ignore
  async addCatDelegaciones(catDelegaciones) {
    try {
      const datoretorno = await this.catDelegacionesService
        .add(catDelegaciones)
        .toPromise();
      return datoretorno;
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    }
  }

  // prettier-ignore
  async getAllCatDelegaciones() {
    try {
      const datoRetorno = await this.catDelegacionesService.getAll().toPromise();
      //ordenamos por descripcion
      this.catDelegaciones = datoRetorno.sort((a, b) => a.descripcion.localeCompare(b.descripcion));
      for (var i = 0, len = this.catDelegaciones.length; i < len; ++i){
        this.catDelegaciones[i].numRow = i;
        this.clonedCatDelegaciones[this.catDelegaciones[i].numRow] = {...this.catDelegaciones[i],        };
      } 
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllCatDelegaciones");
    }
  }

  // prettier-ignore
  async updateCatDelegaciones(catDelegaciones: CatDelegaciones) {
    try {
      const datoRetorno = await this.catDelegacionesService
        .update(catDelegaciones)
        .toPromise();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    }
  }

  // prettier-ignore
  async deleteCatDelegaciones(catDelegaciones: CatDelegaciones) {
    try {
      const datoRetorno = await this.catDelegacionesService
        .delete(catDelegaciones.id)
        .toPromise();
      //this.getAllCatDelegaciones();
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    }
  }

  // obtenemos el catalogo de municipios
  async getCatMunicipios() {
    try {
      const datoRetorno = await this.catMunicipiosService.getAll().toPromise();
      this.catMunicipios = datoRetorno.map((municipio) => {
        return { label: municipio.descripcion, value: municipio.id };
      });
    } catch (e) {
      this.muestraMensaje.error(e.message, "top", "center");
    };
  };

  // obtenemos la descripcion del municipio
  getMunicipioDescripcion(idMunicipio: number): string {
    if (!this.catMunicipios) return '';
    const municipio = this.catMunicipios.find(x => x.value === idMunicipio);
    return municipio ? municipio.label : '';
  }
}